export const getServiceIdFromKey = (key: string) => {
  return Number(key.replace('id', ''))
}

export const getServiceKeyFromId = (id: number) => {
  return `id${id}`
}
